unable to read source [project]/frontend/node_modules/docx-preview/src/numbering/numbering.ts